import { Spinner } from 'reactstrap';
import cls from 'classnames';

const CustomCircularProgress = ({
    label,
    className = '',
    ...restProps
}) => (
    <div className={cls('h-100 w-100 d-flex flex-row flex-nowrap align-items-center justify-content-center', className)}>
        <Spinner {...restProps} />
        { !!label && <span className="ml-3 color-dark">{label}</span>}
    </div>
);

export default CustomCircularProgress;
